import 'vuetify/styles';
import '../main.scss';
import axios from 'axios';
// TODO: why is this ts-ignore needed?
// @ts-ignore
import { createI18n } from 'vue-i18n';
import bookPlayerPlugin, { language } from '@ilteducation/book-player-vue3';
import { storeToRefs } from 'pinia';
import { App } from 'vue';

declare module 'axios' {
    export interface AxiosRequestConfig {
        noAuth?: boolean;
    }
}

// Set up necessary things for the ILT book player
const register = (app: App) => {
    bookPlayerPlugin.install(app);

    axios.interceptors.request.use((request) => {
        if (!request.noAuth) {
            const auth = useAuth();
            const { accessToken } = storeToRefs(auth);

            if (accessToken.value) {
                request.headers.Authorization = `Bearer ${accessToken.value}`;
            }
        }
        return request;
    });

    const i18n = createI18n({
        legacy: false,
        locale: 'dev',
        fallbackLocale: 'dev',
        messages: { dev: language as any },
    });

    app.use(i18n);
};

export default register;
